import { useState } from "react";
import { Download, ExternalLink, FileCheck2, Send } from "lucide-react";
import { Button } from "@/components/ui/button";
import { CATEGORY_MAP } from "@/lib/data";
import { downloadSinaderSheet } from "@/lib/pdf";

const VU_URL = "https://vu.mma.gob.cl/";

export const SinaderPanel = ({ lot }) => {
  const [done, setDone] = useState(false);
  const download = async () => {
    await downloadSinaderSheet(lot, CATEGORY_MAP[lot.category]?.name || lot.category);
    setDone(true);
  };
  const system = lot.hazardous ? "SIDREP" : "SINADER";
  const steps = [
    { t: "Descarga la ficha del lote", d: "PDF con generador, código LER, estado físico y peso." },
    { t: `Ingresa a ${system} en Ventanilla Única`, d: `Con tu ClaveÚnica${lot.generator?.vu_code ? ` y el código de establecimiento ${lot.generator.vu_code}` : " y tu código de establecimiento"}.` },
    { t: "Adjunta la ficha a tu declaración", d: "Usa el código LER y las toneladas exactas de la ficha." },
  ];
  return (
    <div className="bg-[#0a1f18] rounded-2xl p-5 text-white space-y-4 border border-[#1b3d30]" data-testid="sinader-panel">
      <p className="flex items-center gap-2 font-semibold"><Send className="w-4 h-4 text-[#00f2a1]" />Enviar a {system}</p>
      <ol className="space-y-3">
        {steps.map((s, i) => (
          <li key={s.t} className="flex gap-3">
            <span className={`w-6 h-6 rounded-full text-xs font-mono flex items-center justify-center shrink-0 ${i === 0 && done ? "bg-[#00f2a1] text-[#05130e]" : "border border-[#1b3d30] text-[#00f2a1]"}`}>{i === 0 && done ? "✓" : i + 1}</span>
            <div><p className="text-sm font-medium">{s.t}</p><p className="text-xs text-slate-400">{s.d}</p></div>
          </li>
        ))}
      </ol>
      <div className="flex flex-col gap-2">
        <Button onClick={download} className="rounded-full font-semibold" data-testid="sinader-download-btn">
          {done ? <FileCheck2 className="w-4 h-4" /> : <Download className="w-4 h-4" />}Descargar Ficha {system} (PDF)
        </Button>
        <Button asChild variant="outline" className="rounded-full bg-transparent border-[#00f2a1]/40 text-white hover:bg-[#00f2a1]/10 hover:text-white">
          <a href={VU_URL} target="_blank" rel="noreferrer" data-testid="sinader-vu-link"><ExternalLink className="w-4 h-4" />Ir a Ventanilla Única ({system})</a>
        </Button>
      </div>
      <p className="text-[11px] text-slate-500">La declaración oficial la realiza el generador en el portal del Ministerio del Medio Ambiente; terraloop.cl prepara el respaldo.</p>
    </div>
  );
};
